
<template>
  <div
    class="select-file-computer bg-lightest-gray d-flex align-items-center justify-content-center border border-1 rounded rounded-4 border-grey-40 p-50"
    @dragover.prevent
    @drop.stop.prevent="onUploadFile($event, 'Drop')">
    <Spinner
      v-show="getLoaderState"
      :speed="1"
      size="huge"
      message="Loading..."
      class="position-absolute inner-Loader"/>
    <div class="mage-icon text-center">
      <img src="../../assets/images/image-icon.png">
      <p class="mt-16 fs-14 text-medium-gray mb-0">You can drag and drop file to upload</p>
      <label
        for="file-upload"
        class="custom-file-upload lf-btn mt-16 py-7 text-dark-gray fs-14 bg-transparent bm-bordered-btn browse-btn border-1 border border-dark-gray file-upload-btn position-relative">Browse file
      </label>
      <input
        id="file-upload"
        type="file"
        class=" d-none"
        @change="onUploadFile($event, 'Upload')">
    </div>
  </div>

</template>
No Results Matched
<script>
import axios from 'axios';
import EventBus from '@/EventBus';
import Vue from 'vue';
import Spinner from 'vue-simple-spinner';


export default {
  name:       'FileSelect',
  components: {
    Spinner,
  },
  data() {
    return {
      imageData:    null,
      loaderToggle: false,
    };
  },
  computed: {
    getLoaderState() {
      return this.loaderToggle;
    },
  },
  methods: {
    async onUploadFile(e, mood = 'Upload') {
      const target = mood === 'Upload' ? e.target : e.dataTransfer;
      try {
        this.loaderToggle = true;
        if (target.files.length !== 0) {
          const type     = target.files[0].type.split('/');
          const fileName = target.files[0].name;
          const fileSize = target.files[0].size / 1024 / 1024;
          if (fileSize > 20) { throw new Error('File Too Large! File greater than 20 MB cannot be uploaded'); }

          const imageExtension = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase();
          if (type[1] === 'pdf' || (type[0] === 'image' && (imageExtension === 'png' || imageExtension === 'svg' || imageExtension === 'jpg' || imageExtension === 'jpeg'))) {
            let fileToUpload = target.files[0];
            if (type[1] === 'pdf') {
              fileToUpload = await this.handlePDFUpload(target.files[0]);
            }
            this.getBase64(fileToUpload, type[1]);
            target.value = '';
          } else {
            throw new Error('Not a valid image file. Allowed types are .png, .svg, .jpg, .pdf');
          }
        }
      } catch (ex) {
        alert(ex.message);
        this.loaderToggle = false;
      }
    },
    async handlePDFUpload(fileToUpload) {
      const reqFormData = new FormData();
      reqFormData.append('pdf', fileToUpload);
      const headers      = {
        'Content-Type': 'text/plain',
      };
      const res          = await axios.post('https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?return-svg=true', reqFormData, { headers, responseType: 'blob' })
        .catch((err) => {
          throw new Error(err.response.statusText);
        });
      const fileBlob     = await res.data;
      const rand         = Math.random().toString(36).slice(2, 7);
      const fileToReturn = new File([fileBlob], `pdf-${rand}.svg`, { lastModified: 1534584790000 });
      return Promise.resolve(fileToReturn);
    },
    getBase64(file, fileType) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';

      const regextext = /[/\\?%*:|"<>@!~`()• ]/g;
      regextext.test(file.name) && (file =  new File([file.slice(0, file.size, file.type)], file.name.replaceAll(regextext, '-'), { type: file.type }));
      const imageData                 = {
        Id:                   '',
        Name:                 file.name,
        DefaultImageUrl:      '',
        ImageType:            'Image',
        CropOption:           'NotSpecified',
        ImageThumbnailPath:   '',
        ImageThumbnailPathV2: '',
      };
      const imageExtension            = imageData.Name.substring(imageData.Name.lastIndexOf('.') + 1, imageData.Name.length);
      const imageNameWithOutExtension = imageData.Name.substring(0, imageData.Name.lastIndexOf('.'));
      const reqFormData               = new FormData();
      reqFormData.append('file', file);
      const headers = {
        'Content-Type': 'text/plain',
      };

      const serverURL = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      axios.post(`https://${serverURL}.com/webservices/UploadImages.ashx?userId=${userId}`, reqFormData, { headers })
        .then(async (res) => {
          const url                         = res.data;
          imageData.Id                      = url.substring(url.lastIndexOf('#') + 1, url.length);
          const returnedName                = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('#'));
          imageData.previousDefaultImageUrl = `https://www.bankmarketingcenter.com/temp/uploadedimages/${imageData.Id
          }${imageNameWithOutExtension}-resized-600.${imageExtension}#${imageData.Id}`;
          imageData.ImageThumbnailPath      = imageExtension === 'svg' ? url : `https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-${
            returnedName}`;
          imageData.ImageThumbnailPathV2    = imageData.ImageThumbnailPath;
          imageData.DefaultImageUrl         = url.substring(0, url.lastIndexOf('#'));
          EventBus.$emit('AddImageNewImageToMyGalleryImages', imageData);
          this.loaderToggle = false;
          setTimeout(() => {
            EventBus.$emit('AddNewImageOnCanvas', imageData);
          }, 100);
        })
        .catch((e) => {
          throw new Error(e.message);
        });
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
  },
};

</script>
<style lang="scss" scoped>
    .inner-Loader {
        height: 430px;
        width: calc(100% - 80px);
        background: rgb(255,255,255);
        opacity: 0.9;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        z-index: 56;

    }
  .browse-btn {
    min-width: 125px;
  }
  .file-upload-btn {
    input {
      opacity: 0;
      cursor: pointer;
      left: 0;
      top: 0;
    }
  }
</style>
